import daMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/da.json'
import deMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/de.json'
import enMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/en.json'
import esMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/es.json'
import frMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/fr.json'
import hrMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/hr.json'
import itMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/it.json'
import nbMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/nb.json'
import nlMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/nl.json'
import plMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/pl.json'
import svMessages from '@awazevr/mfe-common.contexts.intl/dist/localization/translation-files/search-mfe/sv.json'

export const searchMfeLocaleTranslations = {
  en: enMessages,
  da: daMessages,
  de: deMessages,
  nl: nlMessages,
  nb: nbMessages,
  sv: svMessages,
  es: esMessages,
  fr: frMessages,
  it: itMessages,
  pl: plMessages,
  at: deMessages,
  hr: hrMessages,
}
